import * as React from 'react'
import { TabPanels as ReachTabPanels } from '@reach/tabs'

const TabPanels = (props) => {
  const { isVertical, children, ...whiteListedProps } = props
  return <ReachTabPanels {...whiteListedProps}>{children}</ReachTabPanels>
}

export default TabPanels
